
<template>
  <main class="winners bb">
    <section>
      <PageBackButton />

      <h1 class="pg_title">{{ $_translations.value.page_winners_auth_title }}</h1>
      <h2 class="subtitle">{{ $_translations.value.page_winners_auth_subtitle }}</h2>
    </section>

    <div v-if="error" class="error-state">
      {{ error }}
    </div>

    <template v-else>
      <WinnersAuthPrizeSection
        v-for="prizeType in availablePrizeTypes"
        :key="prizeType"
        :prize-type="prizeType"
        :winners="winnersListPerType[prizeType]"
        :last-updated="lastUpdated.date"
        :is-expanded="expandedSections[prizeType]"
        :max-initial-winners="2"
        @toggle-expansion="toggleExpansion"
      />
    </template>
  </main>
</template>

<script setup>
import { ref, onMounted, computed, getCurrentInstance } from 'vue';
import useWinnersStore from '@/store/modules/winners.js';
import { prizeTypeEnum } from '@/constants/winners.js';
import PageBackButton from '@/components/button/PageBackButton.vue';
import WinnersAuthPrizeSection from '../authenticated/components/section/WinnersAuthPrizeSection.vue';

const winnersStore = useWinnersStore();
const error = ref(null);
const { proxy } = getCurrentInstance();
// Destructure store properties
const {
  winnersListPerType,
  lastUpdated,
  expandedSections,
  dispatchRetrieveWinners,
  toggleExpansion,
} = winnersStore;

// Define the order of prize types to display
const availablePrizeTypes = computed(() => [
  prizeTypeEnum.GRAND,
  prizeTypeEnum.MONTHLY,
  prizeTypeEnum.WEEKLY,
]);

// Load winners on component mount
onMounted(async () => {
  try {
    await dispatchRetrieveWinners();
  } catch {
    error.value = proxy.$_translations.value.page_winners_auth_error_loading_winners;
  }
});
</script>
